import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-lite';
import { MainStoreContextItem } from '../Stores/MainStore';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(({ children }) => {
    const store = MainStoreContextItem.useStore();
    const location = useLocation();

    const isHomePath = location.pathname === '/' || location.pathname === '';

    useEffect(() => {
        // If we're navigating to home/cam area, deauthenticate
        if (isHomePath) {
            store.deAuthenticate();
            return;
        }

        // If we're trying to access a protected route and not authenticated
        if (!store.isAuthenticated.get()) {
            store.requestAuthentication();
        }
    }, [location.pathname, store, isHomePath]);

    // If we're on home path, always render children
    if (isHomePath) {
        return <>{children}</>;
    }

    // If we're on a protected route and not authenticated, don't render children
    if (!store.isAuthenticated.get()) {
        // Return empty div but let the dialog show
        return <div />;
    }

    // Authenticated and on protected route
    return <>{children}</>;
});
